import { Dispatch, SetStateAction } from 'react';

import { Box, List, ListItemButton, ListItemText, Typography } from '@mui/material';

import Button from '@/components/Buttons/Button';
import { spacing } from '@/constants/ui';
import StepButtons from '@/pages/Onboarding/OnboardingForm/Steps/StepButtons';

const usageIds = [
  'Trading',
  'Analysis',
  'Risk Reporting',
  'Audit & Compliance',
  'P&L Reporting',
  'Other',
  'Not sure yet'
];
const Usage = ({
  usage,
  setUsage,
  activeStep,
  setActiveStep,
  handleSubmit
}: {
  usage: string;
  setUsage: (v: string) => void;
  activeStep: number;
  setActiveStep: Dispatch<SetStateAction<number>>;
  handleSubmit: () => void;
}) => {
  return (
    <>
      <Typography
        sx={{ mb: spacing['1.5'] }}
        variant='h3'
      >
        How are you looking to use our data?
      </Typography>
      <List
        aria-label='market-selectlist'
        sx={{
          maxHeight: 'calc(6 * 60px)',
          mb: spacing['2'],
          overflowY: 'scroll'
        }}
      >
        {usageIds.map((usageId, index) => {
          return (
            <ListItemButton
              key={usageId + index}
              selected={usage === usageId}
              sx={{
                backgroundColor: 'rgba(248, 248, 248, 0.20)',
                mb: usageIds.length - 1 > index ? 2 : 0,
                '&.Mui-selected': {
                  border: '2px solid #E84E0F'
                }
              }}
              onClick={() => {
                setUsage(usageId);
              }}
            >
              <ListItemText primary={usageId} />
            </ListItemButton>
          );
        })}
      </List>
      <Box>
        <StepButtons
          activeStep={activeStep}
          nextDisabled={!usage}
          onBackClick={() => {
            setActiveStep(activeStep - 1);
          }}
          onNextClick={() => {
            handleSubmit();
          }}
        />
        <Button
          fullWidth
          disabled={activeStep === 0}
          sx={{
            '&.MuiButton-outlined': {
              color: 'primary.main',
              borderColor: 'primary.main'
            },
            mt: 1
          }}
          variant='outlined'
          onClick={() => {
            handleSubmit();
          }}
        >
          Skip for now
        </Button>
      </Box>
    </>
  );
};
export default Usage;
